export default "__VITE_ASSET__BG9Zv3ra__"